import React, { useEffect, useState } from "react";
//import { Html } from "@react-three/drei";
//import { INITIAL_BREADTH, INITIAL_HEIGHT } from "../../constant/constant.js";
import { Typography } from "../../design_system/StyledComponents/components/Typography.js";
import TextField from "@mui/material/TextField";
import "./PropertiesPopup.css";
import useModes from "../../hooks/useModes.js";
//import useModes from "../../hooks/useModes.js";
import { useDispatch, useSelector } from "react-redux";
import {
  setMeasured,
  setUserLength,
  setUserWidth,
  setUserHeight,
  setSelectedButton
} from "../../features/drawing/drwingSlice.js";
import { setContextualMenuStatus, setShowPopup, setTypeId } from "../../Actions/DrawingActions.js"
import { Button } from "../../design_system/StyledComponents/components/Button.js";
import LengthConverter from "./LengthConverter.js";
import { useActions } from "../../hooks/useActions.js";
import {
  setShowSetScalePopup,
  toggleTutorial,
  setImageOpacity,
  showRoomSeperatorPopup,
  restoreLinesAndPoints,
  setFactor,
  setDesignStep,
  showRoomNamePopup,
  setScaleSetState
} from "../../Actions/ApplicationStateAction.js";
import usePoints from "../../hooks/usePoints.js";
import HowTo from "./HowTo.js";
import { Html } from "@react-three/drei";

// Constants from old code
const INITIAL_BREADTH = 1; // Assuming this is defined in your constants
const INITIAL_HEIGHT = 10; // Assuming this is defined in your constants

// Conversion factors to feet
const UNIT_CONVERSION_TO_FEET = {
  ft: 1,
  inch: 1 / 12,
  mm: 1 / 304.8,
  cm: 1 / 30.48,
  m: 1 / 3.28084,
};

// Scaling factors based on 0.05 units per foot
const SCALING_FACTORS = {
  ft: 0.05,
  inch: 0.05 * 12,
  mm: 0.05 * 304.8,
  cm: 0.05 * 30.48,
  m: 0.05 / 3.28084,
};

const ScalePopup = ({position, type}) => {
  const dispatch = useDispatch();
  const { userLength, userWidth, measured } = useSelector(
    (state) => state.drawing
  );
  const { designStep, showSetScalePopup, img, tutorialActive, 
    selectionMode, backupLines,
  } = useSelector((state) => state.ApplicationState);
  const [error, setError] = useState(false);
  const { handleDoubleClick, handleSaveClick } = useActions();
  const { decimalToFeetInches } = usePoints();
  const [lengthFoot, setLengthFoot] = useState(0);
  const [widthFoot, setWidthFoot] = useState(0);
  const [lengthInch, setLengthInch] = useState(0);
  const [widthInch, setWidthInch] = useState(0);
  const { toggleSelectionMode } = useModes();
  const [unitSelected, setUnitSelected] = useState(false); // Added from old code

  const handleContinueClick = () => {
    if (img) {
      if (measured === "ft") {
        if (lengthFoot <= 0 && lengthInch <= 0) {
          setError(true);
          return;
        }
        const length = parseInt(lengthFoot) + (lengthInch / 12);
        const width = parseInt(widthFoot) + (widthInch / 12);
        dispatch(setUserLength(length));
        dispatch(setUserWidth(width)); // Set userWidth for all units, not just "ft"
        // dispatch(setUserHeight(height));
        handleDoubleClick(length, width);
      } else {
        if (
          userLength <= 0 ||
          userLength === undefined ||
          userLength === ""
        ) {
          setError(true);
          return;
        }
        dispatch(setUserLength(userLength));
        dispatch(setUserWidth(userWidth)); // Set userWidth for all units, not just "ft"
        // dispatch(setUserHeight(height));
        handleDoubleClick(userLength, userWidth);
      }
    } else {
      // No image case from old code
      if (!unitSelected) {
        dispatch(setMeasured("ft"));
        const lfactor = SCALING_FACTORS.ft;
        const wfactor = INITIAL_BREADTH;
        const hfactor = INITIAL_HEIGHT / 10;
        dispatch(setUserLength(5));
        dispatch(setUserWidth(1));
        dispatch(setUserHeight(10));
        dispatch(setFactor([lfactor, wfactor, hfactor]));
      }
      dispatch(setDesignStep(2));
    }
    
    if (showSetScalePopup) {
      dispatch(setShowSetScalePopup(false));
    }
    if (img) {
      window.GAEvent("DrawTool", "ButtonClicked", "Save", designStep);
      if (tutorialActive) {
        dispatch(toggleTutorial(false));
        dispatch(setTypeId(0));
        dispatch(setImageOpacity(0.4));
        dispatch(setSelectedButton(null));
        if (!selectionMode) {
          toggleSelectionMode();
        }
        if (backupLines.length > 0) {
          dispatch(restoreLinesAndPoints());
        }
        return;
      }
      
      // Delay handleSaveClick by 2 second is added to handle the time taken for updating dispatch(setUserLength(5)); in the handleAPICall
      // Its a patch fix 
        // handleSaveClick();
      dispatch(setTypeId(0));
      dispatch(setDesignStep(3));
      dispatch(showRoomNamePopup(true));
      dispatch(setShowPopup(false));
      dispatch(setContextualMenuStatus(false));
      dispatch(setScaleSetState(false));


    }
  };

  useEffect(() => {
    if (userLength > 0 && error && userWidth > 0) {
      setError(false);
    }
  }, [userLength]);

  // useEffect(() => {
  //   if (measured === "ft") {
  //     const length = decimalToFeetInches(userLength);
  //     const width = decimalToFeetInches(userWidth);
  //     setLengthFoot(length.feet);
  //     setLengthInch(length.inches);
  //     setWidthFoot(width.feet);
  //     setWidthInch(width.inches);
  //   }
  // }, [userLength, userWidth, measured]);

  const handleUnitChange = (event) => {
    const newUnit = event.target.value;
    dispatch(setMeasured(newUnit));
    setUnitSelected(true);

    if (!img) {
      const lfactor = SCALING_FACTORS[newUnit];
      const wfactor = INITIAL_BREADTH * UNIT_CONVERSION_TO_FEET[newUnit];
      const hfactor = (INITIAL_HEIGHT / 10) * UNIT_CONVERSION_TO_FEET[newUnit];
      
      const defaults = {
        ft: { length: 5, width: 1, height: 10 },
        inch: { length: 60, width: 12, height: 120 },
        mm: { length: 1524, width: 304.8, height: 3048 },
        cm: { length: 152.4, width: 30.48, height: 304.8 },
        m: { length: 1.524, width: 0.3048, height: 3.048 }
      };
      
      dispatch(setUserLength(defaults[newUnit].length));
      dispatch(setUserWidth(defaults[newUnit].width));
      dispatch(setUserHeight(defaults[newUnit].height));
      dispatch(setFactor([lfactor, wfactor, hfactor]));
    }
  };

  return (
    type === "canvas" ? 
    null
    :
      <div
        className={
          type === "ui" 
            ? "scale-popup-instructions"
            : showSetScalePopup
            ? "scale-popup-overlay"
            : designStep === 1
            ? "scale-popup-container"
            : "scale-popup-container-hidden"
        }
      >
        {/* Row 1: Heading */}
        <div className="scale-popup-row">
          <Typography
            modifiers={["header6", "medium"]}
            style={{ textAlign: "left" }}
          >
            Set wall length
          </Typography>
        </div>
        
        {/* Row 2: How To */}
        <div className="scale-popup-row">
          <HowTo type="setScale" />
        </div>
        
        {/* Row 3: Unit Selection */}
        <div className="scale-popup-row">
          <LengthConverter measured={measured} handleUnitChange={handleUnitChange} />
        </div>
        
        {/* Row 4: Length Input */}
        {
          img ? 
<div className="scale-popup-row">
          {img && <div className="height-input-container">
            <Typography className="height-text">Length</Typography>
            {measured === "ft" ? (
              <div className="feet-input-container">
                <TextField
                  style={{ width: "100%", height: type === "ui" ? "32px" : "34px" }}
                  id="outlined-required"
                  placeholder={measured}
                  label={measured}
                  variant="outlined"
                  size="small"
                  required={true}
                  value={lengthFoot !== "" ? lengthFoot : ""}
                  onChange={(e) =>
                    setLengthFoot(e.target.value ? parseInt(e.target.value) : 0)
                  }
                  InputProps={{
                    style: {
                      fontSize: type === "ui" ? "14px" : "16px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: "400",
                      height: type === "ui" ? "36px" : "44px",
                      borderRadius: "8px",
                    },
                  }}
                />
                <TextField
                  style={{ width: "100%", height: type === "ui" ? "32px" : "34px" }}
                  id="outlined-required"
                  placeholder={"in"}
                  label={"in"}
                  variant="outlined"
                  size="small"
                  required={true}
                  value={lengthInch !== "" ? lengthInch : ""}
                  onChange={(e) => {
                    if (e.target.value.length <= 11)
                      setLengthInch(
                        e.target.value ? parseInt(e.target.value) : 0
                      );
                  }}
                  InputProps={{
                    style: {
                      fontSize: type === "ui" ? "14px" : "16px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: "400",
                      height: type === "ui" ? "36px" : "44px",
                      borderRadius: "8px",
                    },
                  }}
                />
              </div>
            ) : (
              <TextField
                style={{ width: "100%", height: "34px" }}
                id="outlined-required"
                placeholder={measured}
                label={measured}
                variant="outlined"
                size="small"
                required={true}
                value={userLength !== "" ? userLength : ""}
                onChange={(e) => dispatch(setUserLength(e.target.value))}
                InputProps={{
                  style: {
                    fontSize: "16px",
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: "400",
                    height: "44px",
                    borderRadius: "8px",
                  },
                }}
              />
            )}
          </div>}
          {!img && (
            <div className="height-input-container">
              <Typography className="height-text">Length</Typography>
              {measured === "ft" ? (
                <div className="feet-input-container">
                  <TextField
                    style={{ width: "100%", height: type === "ui" ? "32px" : "34px" }}
                    id="outlined-required"
                    placeholder={measured}
                    label={measured}
                    variant="outlined"
                    size="small"
                    required={true}
                    value={lengthFoot !== "" ? lengthFoot : ""}
                    onChange={(e) =>
                      setLengthFoot(e.target.value ? parseInt(e.target.value) : 0)
                    }
                    InputProps={{
                      style: {
                        fontSize: "16px",
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: "400",
                        height: "44px",
                        borderRadius: "8px",
                      },
                    }}
                  />
                  <TextField
                    style={{ width: "100%", height: type === "ui" ? "32px" : "34px" }}
                    id="outlined-required"
                    placeholder={"in"}
                    label={"in"}
                    variant="outlined"
                    size="small"
                    required={true}
                    value={lengthInch !== "" ? lengthInch : ""}
                    onChange={(e) => {
                      if (e.target.value.length <= 11)
                        setLengthInch(
                          e.target.value ? parseInt(e.target.value) : 0
                        );
                    }}
                    InputProps={{
                      style: {
                        fontSize: "16px",
                        fontFamily: "'DM Sans', sans-serif",
                        fontWeight: "400",
                        height: "44px",
                        borderRadius: "8px",
                      },
                    }}
                  />
                </div>
              ) : (
                <TextField
                  style={{ width: "100%", height: type === "ui" ? "32px" : "34px" }}
                  id="outlined-required"
                  placeholder={measured}
                  label={measured}
                  variant="outlined"
                  size="small"
                  required={true}
                  value={userLength !== "" ? userLength : ""}
                  onChange={(e) => dispatch(setUserLength(e.target.value))}
                  InputProps={{
                    style: {
                      fontSize: type === "ui" ? "14px" : "16px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: "400",
                      height: type === "ui" ? "36px" : "44px",
                      borderRadius: "8px",
                    },
                  }}
                />
              )}
            </div>
          )}
          {error && (
            <Typography style={{marginBottom: "-10px"}} modifiers={["warning300", "helpText"]}>
              Please enter a valid value for length
            </Typography>
          )}
        </div>
          : null
        }
        
        
        {/* Row 5: Save & Continue Button */}
        <div className="scale-popup-row">
          <Button
            onClick={handleContinueClick}
            className="save-btn"
            modifiers={["blue", "block"]}
          >
            Save & continue
          </Button>
        </div>
      </div>
  );
};

export default ScalePopup;